<template>
  <v-ons-modal
    class="desktop-modal"
    :visible="showShopListScreen"
    :options="{ animation: animation }"
    @click="detectOutsideClick"
  >
    <div class="content">
      <modal-header
        title="このエリアのお店一覧"
        :back="shouldDisplayBackButton"
        @backClicked="requestSearchScreen"
        @closeClicked="closeModal"
      ></modal-header>

      <div class="modal-body">
        <div v-if="sortedShops && sortedShops.length" :class="listClassName">
          <list-item
            v-for="shop in sortedShops"
            :key="shop.id"
            :shop="shop"
            @itemClicked="selectShop"
          ></list-item>

          <infinite-loading
            v-if="shouldInfiniteLoad"
            :identifier="`${coordinateId};${searchId}`"
            @infinite="infiniteHandler"
          >
          </infinite-loading>
        </div>

        <div v-else>
          <div class="no-stores">該当するお店はありません。</div>
          <!-- The empty holder currently won’t display. If you want it back, remove the v-if="false" from the holder itself -->
          <!-- Fixes random blinking in Firefox -->
          <empty-holder />
        </div>
      </div>
    </div>
  </v-ons-modal>
</template>

<script>
import IconArrowRight from "../assets/icon-arrow-right.svg"
// import IconFace from "../assets/icon-face.svg"
// import IconShop from "../assets/icon-shop.svg"
// import IconMedical from "../assets/icon-medical.svg"
// import IconRestaurant from "../assets/icon-restaurant.svg"
import ModalHeader from "./ModalHeader"
import ListItem from "./ListItem"
import EmptyHolder from "./EmptyHolder"
import { DisplayMode } from "../store/stores"
import { mapGetters, mapActions } from "vuex"
import detectOutsideClick from "../mixins/detectOutsideClick"

export default {
  data() {
    return {
      iconArrowRight: IconArrowRight
    }
  },

  methods: {
    selectShop(shop) {
      this.$emit("shopSelected", shop.id)
    },

    async infiniteHandler(infiniteLoadState) {
      this.fetchMerchants({ infiniteLoadState })
    },

    ...mapActions("stores", ["fetchMerchants"]),
    ...mapActions("nav", ["closeModal", "requestSearchScreen"])
  },

  computed: {
    shouldInfiniteLoad() {
      return (
        this.infinityLoadEnabled && this.sortedShops && this.sortedShops.length
      )
    },

    shouldDisplayBackButton() {
      return this.displayMode == DisplayMode.search
    },

    listClassName() {
      this.$log.debug(window.navigator.userAgent.indexOf("Safari"))

      return (
        "list-content " +
        (window.navigator.userAgent.indexOf("Safari") != -1 &&
        Math.max(
          document.documentElement.clientWidth,
          window.innerWidth || 0
        ) <= 900
          ? "padding-bottom"
          : "")
      )
    },

    animation() {
      return window.innerWidth > 900 ? "fade" : "lift"
    },

    ...mapGetters("map", ["coordinateId"]),
    ...mapGetters("stores", [
      "displayMode",
      "endReached",
      "sortedShops",
      "searchId"
    ]),
    ...mapGetters("nav", ["infinityLoadEnabled", "showShopListScreen"])
  },

  mixins: [detectOutsideClick],

  components: {
    EmptyHolder,
    ModalHeader,
    ListItem
  }
}
</script>
<style>
</style>